import { type JSX, Show, createMemo, createSignal } from "solid-js";

import { SidebarContainerState } from "@/stores/sidebarContainerStore.ts";

type SidebarContainerProps = {
  state: SidebarContainerState;
  children: JSX.Element;
};

// 通知组件使用，TODO: 聊天室可用
export function SidebarContainer(props: SidebarContainerProps) {
  const [isExpanded, setIsExpanded] = createSignal(false);
  const shouldShowContent = createMemo(() => {
    if (props.state.isExpanded) {
      setIsExpanded(true);
    }
    return isExpanded();
  });
  const handleTransitionEnd = () => {
    if (!props.state.isExpanded) {
      setIsExpanded(false);
    }
  };
  return (
    // --notification-width
    <div
      class={`bg-general-bg2 h-full overflow-y-auto transition-[width] duration-300 ease-in-out ${props.state.isExpanded ? "w-[400px]" : "w-[0px]"}`}
      onTransitionEnd={handleTransitionEnd}
    >
      {/* 防止展开时内容出现伸缩 --notification-width */}
      <div class="flex h-full w-[400px] flex-col gap-[10px] px-[12px] text-white">
        {/*每次打开更新内部*/}
        <Show when={shouldShowContent()} fallback={<></>}>
          {props.children}
        </Show>
      </div>
    </div>
  );
}
